import type { UserRole } from '@/features/auth/types';
import type { OnboardingChapter } from '@/features/onboarding/types';
import { welcomeTour } from '@/features/onboarding/welcome-tour';

/** The only onboarding deck. Slides are added in `welcome-tour.ts`, never from a changelog release. */
export const onboardingChapters: OnboardingChapter[] = [welcomeTour];

export function getChaptersForRole(role: UserRole): OnboardingChapter[] {
  return onboardingChapters
    .map(chapter => ({
      ...chapter,
      slides: chapter.slides.filter(slide => !slide.audience || slide.audience.includes(role)),
    }))
    .filter(chapter => chapter.slides.length > 0);
}
